export const leaderboardSizes = ['large', 'medium', 'small'];
export const leaderboardSizesMap = {
  large: {
    labelKey: 'commons.challenges.leaderboard.label_companies_large',
    titleKey: 'commons.challenges.leaderboard.title_companies_large',
    descriptionKey: 'commons.challenges.leaderboard.description_companies_large'
  },
  medium: {
    labelKey: 'commons.challenges.leaderboard.label_companies_medium',
    titleKey: 'commons.challenges.leaderboard.title_companies_medium',
    descriptionKey: 'commons.challenges.leaderboard.description_companies_medium'
  },
  small: {
    labelKey: 'commons.challenges.leaderboard.label_companies_small',
    titleKey: 'commons.challenges.leaderboard.title_companies_small',
    descriptionKey: 'commons.challenges.leaderboard.description_companies_small'
  }
};